module.exports = __webpack_public_path__ + "static/media/login_insta_android.5874e884.svg";